






































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Button, Form, FormItem, Input, Option, Select } from 'element-ui';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import statusOptions from '@/constants/billStatusOptions';
import {
  BillInput,
  BillFields,
  BillStatusEnum,
  AvailableLocalesEnum
} from '@/types/graphql/schemaTypes';
import omit from 'lodash/omit';
import { SelectOption } from '@/types/types';
import { languageOptions } from '@/constants/languages';

@Component({
  components: {
    'utc-date-picker': UtcDatePicker,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class BillModal extends Vue {
  @Prop({}) public baseProps!: BillFields;

  private bill: BillInput = {
    status: this.baseProps.status
  };

  private forceClose = true;
  private statusOptions: SelectOption<BillStatusEnum>[] = [];

  private readonly languageOptions = languageOptions();

  private created(): void {
    this.statusOptions = statusOptions(this.$t.bind(this));
  }

  get isActive() {
    return !!this.baseProps && !this.forceClose;
  }

  get isValid() {
    return this.bill.status !== BillStatusEnum.draft;
  }

  get billStatus(): SelectOption<BillStatusEnum> {
    return this.statusOptions.find((option) => {
      return (option.value === this.bill.status);
    }) || { label: `${this.$t('bill.status.draft')}`, value: BillStatusEnum.draft };
  }

  set billStatus(status: SelectOption<BillStatusEnum>) {
    this.bill.status = (status) ? status.value : BillStatusEnum.draft;
  }

  private close(): void {
    this.forceClose = true;
  }

  private confirm(): void {
    this.storeData(this.bill);
  }

  private storeData(newStoreData: any) {
    this.forceClose = true;
    this.$store.commit('Bill/setUpdateBillAttrs', { ...newStoreData });
  }

  @Watch('baseProps')
  private update() {
    if (this.statusOptions.find(s => s.value === BillStatusEnum.draft)) {
      this.statusOptions.splice(
        this.statusOptions.findIndex(s => s.value === BillStatusEnum.draft), 1
      );
    }
    this.forceClose = false;
    this.bill = omit(this.baseProps, ['shipments', 'pdfFile']);
  }
}
